import { ethers } from "ethers";

/** Minimal ABI for V2 wallet mint + reads (matches TreydoraEdBackend slim ABI). */
export const TREYDORA_GENESIS_COMIC_721_V2_ABI = [
  "function mintWithETH(uint256 tokenId) payable returns (uint256)",
  "function tokenEthPrice(uint256 tokenId) view returns (uint256)",
  "function ownerOf(uint256 tokenId) view returns (address)",
];

/**
 * @param {ethers.Signer | ethers.providers.Provider} signerOrProvider
 * @param {string} contractAddressChecksummed
 */
export function getTreydoraGenesisComic721V2Contract(signerOrProvider, contractAddressChecksummed) {
  return new ethers.Contract(contractAddressChecksummed, TREYDORA_GENESIS_COMIC_721_V2_ABI, signerOrProvider);
}

export async function readV2TokenEthPrice(contract, tokenId) {
  const tid = ethers.BigNumber.from(tokenId);
  return contract.tokenEthPrice(tid);
}

export async function readV2OwnerOf(contract, tokenId) {
  const tid = ethers.BigNumber.from(tokenId);
  return contract.ownerOf(tid);
}

/**
 * @param {ethers.Contract} contract — connected with signer
 * @param {number|string} tokenId
 * @param {ethers.BigNumber} valueWei — must equal tokenEthPrice(tokenId)
 */
export async function mintWithEthV2(contract, tokenId, valueWei) {
  const tid = ethers.BigNumber.from(tokenId);
  const tx = await contract.mintWithETH(tid, { value: valueWei });
  const receipt = await tx.wait(1);
  return { tx, receipt };
}
